import {
  PSMS_PAYMENT_INTEGRITY_DATA_REQUEST,
  PSMS_PAYMENT_INTEGRITY_DATA_SUCCESS,
  PSMS_PAYMENT_INTEGRITY_DATA_FAILURE,
  PSMS_PAYMENT_INTEGRITY_DATA_LOADING,
  PSMS_EVAlUATION_DETAILS_DATA_LOADING,
  PSMS_EVAlUATION_DETAILS_DATA_SUCCESS,
  PSMS_AUDIT_REASON_CODE_DATA_LOADING,
  PSMS_AUDIT_REASON_CODE_DATA_SUCCESS,
} from '../../../actions/actionTypes';

interface PaymentIntegrityState {
  DenialRate: any;
  isLoading: boolean;
  error: any;
  evaluationDetailsData: any;
  isEvaluationDetailsLoading: any;
  auditCodeReasons: any;
  isAuditCodeReasonsLoading: any;
}

const initialState: PaymentIntegrityState = {
  DenialRate: null,
  isLoading: true,
  error: null,
  evaluationDetailsData: null,
  isEvaluationDetailsLoading: true,
  auditCodeReasons: [],
  isAuditCodeReasonsLoading: true,
};

const PsmsPaymentIntegrityReducer = (
  state = initialState,
  action: { type: string; payload?: any }
): PaymentIntegrityState => {
  switch (action.type) {
    case PSMS_PAYMENT_INTEGRITY_DATA_REQUEST:
      return {
        ...state,
        isLoading: true,
        DenialRate: null,
        error: null,
      };
    case PSMS_PAYMENT_INTEGRITY_DATA_SUCCESS:
      return {
        ...state,
        DenialRate: action.payload,
        error: null,
      };
    case PSMS_PAYMENT_INTEGRITY_DATA_FAILURE:
      return {
        ...state,
        error: action.payload,
        DenialRate: null,
      };
    case PSMS_PAYMENT_INTEGRITY_DATA_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    case PSMS_EVAlUATION_DETAILS_DATA_LOADING:
      return {
        ...state,
        isEvaluationDetailsLoading: action.payload,
      };
    case PSMS_EVAlUATION_DETAILS_DATA_SUCCESS:
      return {
        ...state,
        evaluationDetailsData: action.payload,
      };
    case PSMS_AUDIT_REASON_CODE_DATA_LOADING:
      return {
        ...state,
        isAuditCodeReasonsLoading: action.payload,
      };
    case PSMS_AUDIT_REASON_CODE_DATA_SUCCESS:
      return {
        ...state,
        auditCodeReasons: action.payload,
      };
    default:
      return state;
  }
};

export default PsmsPaymentIntegrityReducer;
